import { render } from "./RatioContent.vue?vue&type=template&id=12bb2122"
import script from "./RatioContent.vue?vue&type=script&lang=js"
export * from "./RatioContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__